const allowedTlds = [
  ".com", ".net", ".mx", ".org.mx", ".org", ".com.mx", ".biz", ".net.mx", ".edu.mx", ".gob.mx",
  ".tv", ".info", ".us", ".name", ".eu", ".cc", ".mobi", ".ws", ".me", ".in", ".asia", ".co",
  ".xxx", ".pro", ".tel", ".co.uk", ".space", ".website", ".xyz", ".lol", ".party", ".host",
  ".fun", ".store", ".tech", ".online", ".site", ".press", ".lat", ".uk", ".de", ".vip", ".uno",
  ".work", ".fit", ".casa", ".app", ".io", ".ai"
];
const noAllowedTransferTlds = [".ai"];

/**
 * Validates if the domain is valid
 * If the domain is valid, it returns the cleaned domain
 * @param string input value of the domain
 * @param bool requireTld if true, the domain must have a TLD
 * @param bool inTldList if true, the domain must have a TLD from the allowed list
 * @param string typeDomain "register|transfer"
 * @return "{isValid: (bool), cleanDomain: (null|domain), error: (null|"tld_register"|"tld_transfer")}"
 */
const validateAndCleanDomain = (input, requireTld = false, inTldList = false, typeDomain = 'register') => {
  if (!input || typeof input !== "string") {
    return { isValid: false, cleanDomain: null, error: null };
  }

  input = input.trim().toLowerCase();

  // Prevalidation that seek if the domain contains a TLD
  const tldMatch = input.match(/^(?:https?:\/\/)?(?:www\.)?((?!-)[a-zA-Z0-9-]{1,63}(?<!-))(\.[a-zA-Z]{2,63}(?:\.[a-zA-Z]{2,63})?)$/);
  const hasTld = !!tldMatch;
  const tld = hasTld ? tldMatch[2] : null;

  // If the TLD doesn't in the array the validation returns false
  if (inTldList && hasTld) {
    switch (typeDomain) {
      case 'register':
        if(!allowedTlds.includes(tld)) {
          return { isValid: false, cleanDomain: null, error: "tld_register" };
        }
        break;

      case 'transfer':
        if (!allowedTlds.includes(tld) || (allowedTlds.includes(tld) && noAllowedTransferTlds.includes(tld))) {
          return { isValid: false, cleanDomain: null, error: "tld_transfer" };
        }
        break;
    
      default:
        break;
    }
  }

  // Regex to domains with TLD
  const domainWithTLDRegex = /^(?:https?:\/\/)?(?:www\.)?((?!-)[a-zA-Z0-9-]{1,63}(?<!-))(\.[a-zA-Z]{2,63}(?:\.[a-zA-Z]{2,63})?)$/;
  // Regex to domains without TLD
  const domainWithoutTLDRegex = /^(?:https?:\/\/)?(?:www\.)?((?!-)[a-zA-Z0-9-]{1,63}(?<!-))$/;

  // Use the regex previous chosen
  const regex = requireTld || hasTld ? domainWithTLDRegex : domainWithoutTLDRegex;
  const match = input.match(regex);

  if (!match) {
    return { isValid: false, cleanDomain: null, error: null };
  }
  // Set the string to search
  const cleanDomain = `${match[1]}${match[2] || ""}`;

  return { isValid: true, cleanDomain, error: null };
};

export default validateAndCleanDomain;
